module.exports = __webpack_public_path__ + "img/home-07-cosmo-02-timeline-04.a47fd498.jpg";